import { createUseStyles } from "react-jss";
import { theme } from "$utils/theme/bataillog";

export const useStyles = createUseStyles(() => ({
  wrapper: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    gap: theme.spacing(1),
  },
  errorField: {
    minHeight: 20,
    color: `${theme.color.red} !important`,
    fontSize: `12px !important`,
  },
}));
